import {Component, HostListener, OnInit} from '@angular/core';
import {MerchantApi} from "../../../common/apis/merchant-api";
import {Merchant} from "../../../common/interfaces/Merchant";
import {FormBuilder, FormGroup} from "@angular/forms";
import {DeliveryArea, MerchantFilters} from "../../../common/interfaces/MerchantFiltersResponse";
import {AppliedFilters} from "../../../common/interfaces/AppliedFilters";
import {AppliedMerchantFilters} from "../../../common/interfaces/AppliedMerchantFilters";
import {ActivatedRoute} from "@angular/router";
import {MerchantListFiltersModalComponent} from "./merchant-list-filters-modal/merchant-list-filters-modal.component";
import {MatBottomSheet} from '@angular/material/bottom-sheet';


@Component({
  selector: 'merchant-list-page',
  templateUrl: './merchant-list-page.component.html',
  styleUrls: ['./merchant-list-page.component.scss']
})
export class MerchantListPageComponent implements OnInit {

  merchants: Merchant[] = []
  formGroup: FormGroup;
  filters: AppliedMerchantFilters
  charactersToSearch: string = "";
  loading: boolean = false
  loadingSearchResults: boolean = false
  merchantFilters: MerchantFilters
  deliveryAreas: DeliveryArea[] = []

  citiesCheckBoxes: boolean[] = []

  deliveryAreasCheckBoxes: boolean[] = []

  categoriesCheckBoxes: boolean[] = []

  readyWithinCheckBoxes: boolean[] = []

  mealStateCheckBoxes: boolean[] = []

  deliveryAvailableCheckBox: boolean = false
  pickUpAvailableCheckBox: boolean = false

  maxPrice: number = 0
  minPrice: number = 0

  pageNumber: number = 1
  showLoadMoreButton: boolean = true

  isMobileView: boolean = false

  loadMoreRestaurantsLabel = $localize`:@@loadMoreRestaurants:Load more restaurants`

  constructor(
    private fb: FormBuilder,
    private merchantApi: MerchantApi,
    private route: ActivatedRoute,
    private bottomSheet: MatBottomSheet
  ) {
  }

  ngOnInit(): void {
    if (window.innerWidth < 770) {
      this.isMobileView = true
    }
    this.charactersToSearch = this.route.snapshot.queryParamMap.get('text') ?? ""
    let categoryId = this.route.snapshot.queryParamMap.get('categoryId')
    if (this.charactersToSearch.length > 0) {
      this.search()
    } else if (categoryId !== null) {
      this.filters = {
        deliveryAvailable: false,
        pickupAvailable: false,
        price: {
          from: null,
          to: null,
        },
        appliedFilters: [
          {
            name: "categoryId",
            filters: [categoryId]
          }
        ]
      }
      this.search()
    } else {
      this.getMerchants()
    }
    this.formGroup = this.fb.group({
      'search': ['']
    })
    this.formGroup.get('search')!.valueChanges.subscribe(response => {
      this.charactersToSearch = response
    });
    if (this.charactersToSearch.hasActualValue()) {
      this.formGroup.get('search')?.setValue(this.charactersToSearch)
    }
    this.merchantApi.getMerchantFilters().subscribe({
      next: (response) => {
        this.merchantFilters = response
        this.minPrice = this.merchantFilters.price.min
        this.maxPrice = this.merchantFilters.price.max
        this.setDeliveryAreasShown()
        if (categoryId !== null) {
          let indexOfCategory = this.merchantFilters.categories.findIndex((value) => value.id === categoryId)
          if (indexOfCategory !== null) {
            this.categoriesCheckBoxes[indexOfCategory] = true
          }
        }
      }
    })
  }

  loadMore() {
    if (Object.keys(this.filters).length === 0 && this.charactersToSearch.length === 0) {
      this.getMerchants()
    } else {
      this.search()
    }
  }

  getMerchants() {
    this.loadingSearchResults = true
    this.merchantApi.getMerchants(this.pageNumber).subscribe({
      next: (merchantsResponse) => {
        this.loadingSearchResults = false
        if (merchantsResponse.data.length < 15) {
          this.showLoadMoreButton = false
        } else {
          this.showLoadMoreButton = true
          this.pageNumber++
        }
        this.merchants.push(...merchantsResponse.data)
      },
      error: (_) => {
        this.loadingSearchResults = false
      }
    })
  }

  search() {
    this.loadingSearchResults = true
    this.merchantApi.search(this.pageNumber, this.charactersToSearch, this.filters).subscribe({
      next: (merchantsResponse) => {
        this.loading = false
        this.loadingSearchResults = false
        this.merchants = merchantsResponse.data
        if (merchantsResponse.data.length >= 15) {
          this.showLoadMoreButton = true
          this.pageNumber++
        } else {
          this.showLoadMoreButton = false
        }
      },
      error: (_) => {
        this.loadingSearchResults = false
      }
    })
  }

  @HostListener('document:keydown', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    if (event.key === "Enter" && !this.loading) {
      this.search()
    }
  }

  onClearCitiesClicked() {
    for (let i = 0; i < this.merchantFilters.cities.length; i++) {
      this.citiesCheckBoxes[i] = false
      this.setDeliveryAreasShown()
    }
    this.filterResults()
  }

  onClearDeliveryAreasClicked() {
    for (let i = 0; i < this.merchantFilters.deliveryAreas.length; i++) {
      this.deliveryAreasCheckBoxes[i] = false
    }
    this.filterResults()
  }

  onClearCategoriesClicked() {
    for (let i = 0; i < this.merchantFilters.categories.length; i++) {
      this.categoriesCheckBoxes[i] = false
    }
    this.filterResults()
  }

  onClearCookStateClicked() {
    for (let i = 0; i < this.merchantFilters.state.values.length; i++) {
      this.mealStateCheckBoxes[i] = false
    }
    this.filterResults()
  }

  onClearReadyWithinClicked() {
    for (let i = 0; i < this.merchantFilters.readyWithin.values.length; i++) {
      this.readyWithinCheckBoxes[i] = false
    }
    this.filterResults()
  }

  format(value: number): string {
    return (value / 100).toString()
  }

  filterAreas() {
    let filteredCities: string[] = []
    for (let i = 0; i < this.citiesCheckBoxes.length; i++) {
      if (this.citiesCheckBoxes[i]) {
        filteredCities.push(this.merchantFilters.cities[i].id)
      }
    }
    if (filteredCities.isEmpty()) {
      this.setDeliveryAreasShown()
    } else {
      this.deliveryAreas = this.merchantFilters.deliveryAreas.filter((area, _, __) => {
        return filteredCities.includes(area.city)
      })
    }
  }

  filterResults() {
    this.loadingSearchResults = true
    this.pageNumber = 1
    this.filters = {
      deliveryAvailable: this.deliveryAvailableCheckBox,
      pickupAvailable: this.pickUpAvailableCheckBox,
      price: {
        from: this.minPrice === this.merchantFilters.price.min ? null : this.minPrice,
        to: this.maxPrice === this.merchantFilters.price.max ? null : this.maxPrice,
      },
      appliedFilters: this.getAppliedFilters()
    }
    this.filterProducts()
  }

  getAppliedFilters() {
    let appliedFilters: AppliedFilters[] = []
    let filteredCategories: string[] = []
    for (let i = 0; i < this.categoriesCheckBoxes.length; i++) {
      if (this.categoriesCheckBoxes[i]) {
        filteredCategories.push(this.merchantFilters.categories[i].id)
      }
    }
    appliedFilters.push({
      name: "categoryId",
      filters: filteredCategories
    })
    let filteredAreas: string[] = []
    for (let i = 0; i < this.deliveryAreasCheckBoxes.length; i++) {
      if (this.deliveryAreasCheckBoxes[i]) {
        filteredAreas.push(this.merchantFilters.deliveryAreas[i].id)
      }
    }
    appliedFilters.push({
      name: "areaId",
      filters: filteredAreas
    })
    let filteredCities: string[] = []
    for (let i = 0; i < this.citiesCheckBoxes.length; i++) {
      if (this.citiesCheckBoxes[i]) {
        filteredCities.push(this.merchantFilters.cities[i].id)
      }
    }
    appliedFilters.push({
      name: "cityId",
      filters: filteredCities
    })
    let filteredState: string[] = []
    for (let i = 0; i < this.mealStateCheckBoxes.length; i++) {
      if (this.mealStateCheckBoxes[i]) {
        filteredState.push(this.merchantFilters.state.values[i].id)
      }
    }
    appliedFilters.push({
      name: "state",
      filters: filteredState
    })
    let filteredReadyWithin: string[] = []
    for (let i = 0; i < this.readyWithinCheckBoxes.length; i++) {
      if (this.readyWithinCheckBoxes[i]) {
        filteredReadyWithin.push(this.merchantFilters.readyWithin.values[i].id)
      }
    }
    appliedFilters.push({
      name: "readyWithin",
      filters: filteredReadyWithin
    })
    return appliedFilters
  }


  @HostListener('window:resize', ['$event'])
  onResize(_: any) {
    this.isMobileView = window.innerWidth < 770 && window.innerHeight < 1020;
    if (!this.isMobileView) {
      this.bottomSheet.dismiss()
    }
  }

  showModalFilters() {
    const filterModalSheet = this.bottomSheet.open(MerchantListFiltersModalComponent, {
      data: {
        filters: this.merchantFilters,
        appliedFilters: this.filters
      }
    });
    filterModalSheet.afterDismissed().subscribe({
      next: (filters: AppliedMerchantFilters) => {
        this.filters = filters
        this.filterProducts()
      }
    })
  }

  filterProducts() {
    this.merchantApi.search(this.pageNumber, this.charactersToSearch, this.filters).subscribe({
      next: (merchantsResponse) => {
        this.loadingSearchResults = false
        this.merchants = merchantsResponse.data
        this.showLoadMoreButton = merchantsResponse.data.length > 14;
      },
      error: (_) => {
        this.loadingSearchResults = false
      }
    })
  }

  showAllAreas() {
    this.deliveryAreas = this.merchantFilters.deliveryAreas
  }

  collapseAreas() {
    this.deliveryAreas = this.merchantFilters.deliveryAreas.slice(0, 10)
  }

  private setDeliveryAreasShown() {
    if (this.merchantFilters.deliveryAreas.length > 10) {
      this.deliveryAreas = this.merchantFilters.deliveryAreas.slice(0, 10)
    } else {
      this.deliveryAreas = this.merchantFilters.deliveryAreas
    }
  }

  shouldShowMore(): boolean {
    return this.merchantFilters.deliveryAreas.length >= 10 && !this.citiesCheckBoxes.includes(true) && this.deliveryAreas.length <= 10
  }

  shouldShowLess(): boolean {
    return this.deliveryAreas.length > 10 && !this.citiesCheckBoxes.includes(true)
  }
}
